{
  "fr": {
    "wysiwyg": {
      "actions": {
        "alignCenter": "Aligner au centre",
        "alignLeft": "Aligner à gauche",
        "alignRight": "Aligner à droite",
        "blockType": "Type de paragraphe",
        "blockquote": "Citation",
        "bold": "Gras",
        "bulletList": "Liste non ordonnée",
        "code": "Code",
        "codeBlock": "Bloc de code",
        "fontFamily": "Famille de polices",
        "fontSize": "Taille de police",
        "h1": "Titre 1",
        "h2": "Titre 2",
        "h3": "Titre 3",
        "highlight": "Surligner",
        "horizontalRule": "Ligne de séparation",
        "iframe": "Intégrer un iFrame",
        "images": "Insérer des images",
        "italic": "Italique",
        "katex": "Formule LaTeX",
        "katexBlock": "Bloc de formule LaTeX",
        "link": "Lien",
        "more": "Options d'insertion",
        "orderedList": "Liste ordonnée",
        "redo": "Rétablir",
        "specialCharacters": "Caractères spéciaux",
        "strikethrough": "Barré",
        "table": "Tableau",
        "textColor": "Couleur du texte",
        "underline": "Souligné",
        "undo": "Annuler"
      },
      "blockTypes": {
        "five": "Titre 5",
        "four": "Titre 4",
        "one": "Titre 1",
        "paragraph": "Paragraphe",
        "six": "Titre 6",
        "three": "Titre 3",
        "two": "Titre 2"
      },
      "colors": {
        "default": "Standard",
        "gray": "Gris",
        "indigo": "Indigo",
        "magenta": "Magenta",
        "orange": "Orange",
        "petrol": "Pétrole",
        "purple": "Violet",
        "red": "Rouge",
        "teal": "Turquoise"
      },
      "dialogs": {
        "deleteTable": {
          "text": "Le tableau sera supprimé avec tout son contenu.",
          "title": "Supprimer le tableau ?"
        },
        "iframe": {
          "text": "Saisissez l'URL de la page à intégrer sous forme d'iFrame dans le texte.",
          "title": "Intégrer un iFrame"
        },
        "link": {
          "text": "Saisissez l'URL vers laquelle le texte sélectionné doit renvoyer.",
          "title": "Insérer un lien"
        },
        "urlPrompt": {
          "label": "URL",
          "placeholder": "Exemple : https://example.com"
        }
      },
      "errors": {
        "imageFormatUnsupported": "Ce format d'image ne peut pas être affiché dans le texte.",
        "imageInsertFailed": "L'image n'a pas pu être insérée."
      },
      "specialCharactersModal": {
        "categories": {
          "Arrows": "Flèches",
          "Basic Latin": "Latin de base",
          "Currency Symbols": "Symboles monétaires",
          "Dingbats": "Dingbats",
          "Enclosed Alphanumerics": "Caractères alphanumériques entre parenthèses",
          "General Punctuation": "Ponctuation générale",
          "Geometric Shapes": "Formes géométriques",
          "Greek and Coptic": "Grec et copte",
          "Latin Extended-A": "Latin étendu-A",
          "Latin Extended-B": "Latin étendu-B",
          "Latin-1 Supplement": "Supplément Latin-1",
          "Mathematical Operators": "Opérateurs mathématiques",
          "Miscellaneous Symbols": "Symboles divers",
          "Miscellaneous Technical": "Caractères techniques divers",
          "Superscripts and Subscripts": "Exposants et indices"
        },
        "header": "Caractères spéciaux"
      }
    }
  }
}
